module.exports = __webpack_public_path__ + "img/MagnifyingGlassDesktop.b2b865fd.svg";